import { taxReturnFormsUrl } from 'app/http/apiRoutes';
import httpApiApplication from 'app/http/httpApiApplication';

import { type FormStatement } from '../types';

export const baseUrl = taxReturnFormsUrl;

export function updateFormStatement(id: string, request: FormStatement) {
  return httpApiApplication.put(`${baseUrl}/${id}`, request);
}

export function deleteFormStatement(id: string) {
  return httpApiApplication.delete(`${baseUrl}/${id}`);
}

export const createFormStatement = (request: FormStatement) => {
  return httpApiApplication.post(baseUrl, request);
};
